import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getPersonaRpp } from '../api/consultaRppApi';
import { withRouter } from "../hooks/withRouter";

import { UseAuth } from "../hooks/useAuth";

function BusquedaRpp(props) {
  const { location } = props.router;
  const [result, setResult] = useState([])
  const [loading, setLoading] = useState(true);

  const { accessToken } = UseAuth();

  const [error, setError] = useState(null);


 useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPersonaRpp(accessToken, location.search);
        setResult(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [accessToken, location.search]);

  if (error) {
    // Lanzar error dentro del render para que ErrorBoundary lo capture
    throw error;
  }







  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000); // Tiempo de espera en milisegundos (en este caso 3 segundos)

    return () => clearTimeout(timeout);
  }, []); // Se ejecuta solo en el montaje inicial

  if (loading) {
    return (
      <div className='padron'>
        <div className='top-bar2'>
          <div className="top-bar">
            <div className="logo">
              {/* Botón con apariencia de logo que lleva a la página principal */}
              <Link to="/">
                <button className="logo-button">
                  <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <h1>Consulta RPP</h1>

        <div className='padron'>Buscando...</div>
      </div>
    );
  }

  if (result.length === 0) {
    return (
      <div className='padron'>
        <div className='top-bar2'>
          <div className="top-bar">
            <div className="logo">
              {/* Botón con apariencia de logo que lleva a la página principal */}
              <Link to="/">
                <button className="logo-button">
                  <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <h1>Consulta RPP</h1>

        <div className='padron'>No hay resultados</div>
      </div>
    );
  }


  return (
    <div>

      <div className='top-bar2'>
        <div className="top-bar">

          <div className="logo">
            {/* Botón con apariencia de logo que lleva a la página principal */}
            <Link to="/">
              <button className="logo-button">
                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className='padron'>

    <div className='results'>
      <h1>Consulta Rpp</h1>
      <div className='results-container'>
      <ul >
        {result.map((res, index) => (

<li className="res-list"  key={index}>


            <Link to={`/rpp-detalles/${res.NOMBRE}`} >
              <h1>{res.NOMBRE}</h1>
            </Link>

          </li>

        ))}
      </ul>
    </div>
    </div>
    </div>
    </div>
  )
}

export default withRouter(BusquedaRpp);
